import { Loader } from "lucide-react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectGroup, SelectItem } from "components/ui/select"; // or wherever your library path is
import { Label } from "components/ui/label";
import NumberInput from "components/app/function/NumberInput";
import SwitchYesNoWithLabel from "components/app/function/SwitchYesNoWithLabel";
import { Button } from "components/ui/button";

const PayrollSetting = ({ payrollSetting, handleInputChange, formValues, setFormValues, setPayrollSetting, submitShopPayrollSetting, loadingsubmitShopPayrollSetting }: any) => {
  return (
    <div className="grid gap-4">
      <div className="space-y-2">
        <h4 className="font-medium leading-none">Setting</h4>
        <p className="text-sm text-muted-foreground">Employee Earnings, Deductions, and Tax Setting..</p>
      </div>
      <div className="flex lg:flex-row md:flex-row flex-col justify-between gap-2  p-0">
        <div className="space-y-2 pe-5 mt-0 ">
          <div className="flex items-center justify-between gap-2">
            <div className="w-full space-y-2">
              <Label> Monthly </Label>
              <br />

              <Select onValueChange={(val) => handleInputChange("payroll_pay_option", val)}>
                <SelectTrigger className=" focus:border-none">
                  <SelectValue placeholder={formValues.payroll_pay_option} />
                </SelectTrigger>
                <SelectContent className="">
                  <SelectGroup>
                    <SelectItem value="monthly">{formValues.payroll_pay_option}</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
            <div className="w-full space-y-2">
              <Label> Seniority Tax Allowance </Label>
              <br />

              <NumberInput
                id="seniority_tax_allowance"
                value={formValues.seniority_tax_allowance > 0 && formValues.seniority_tax_allowance}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    seniority_tax_allowance: e.target.value,
                  })
                }
              />
            </div>
          </div>
          {[
            ["transport_allownace", "housing_allownace"],
            ["phone_allownace", "food_allownace"],
            ["other_allownace", "commission_pay"],
            ["advance_pay", "overtime_pay"],
            ["loan_deduction", "advance_deduction"],
            ["other_deduction", "pension_deduction"],
          ].map((pair, i) => (
            <div key={i} className="flex gap-2 justify-between items-center">
              {pair.map((key) => (
                <div key={key} className="w-full capitalize mt-[13px] bg-gray-100 dark:border-[1px] dark:border-gray-200 dark:bg-transparent rounded-md">
                  <SwitchYesNoWithLabel id={key} label={` ${key.replace(/_/g, " ")}`} value={formValues[key]} onChange={(val: any) => handleInputChange(key, val)} />
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className="space-y-2 w-[350px] ">
          <Label>Tax Setting </Label>
          <table className="min-w-full border-collapse mb-20  overflow-hidden">
            <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-50 dark:bg-[#2c3a52] dark:text-gray-400">
              <tr className="border ">
                <th className="px-4 py-5 border ">Gross Pay </th>
                <th className="px-4 py-5 border ">Tax Rate</th>
              </tr>
            </thead>
            <tbody>
              {payrollSetting?.tax_settings?.map((item: any, index: number) => {
                return (
                  <tr key={index} className={`text-center`}>
                    <td className=" p-1 text-md border">
                      <NumberInput
                        value={item.gross_pay_from > 0 && item.gross_pay_from}
                        type="number"
                        className="w-full h-full border-none py-1 rounded-none bg-transparent text-end focus:border-none"
                        onChange={(e) => {
                          const updatedSettings = [...payrollSetting.tax_settings];
                          updatedSettings[index].gross_pay_from = parseFloat(e.target.value) || 0;
                          setPayrollSetting({ ...payrollSetting, tax_settings: updatedSettings });
                        }}
                      />
                    </td>
                    <td className="p-1 text-md border">
                      <NumberInput
                        value={item.tax_rate > 0 && item.tax_rate}
                        type="number"
                        className="w-full h-full border-none py-1 rounded-none bg-transparent text-end focus:border-none"
                        onChange={(e) => {
                          const updatedSettings = [...payrollSetting.tax_settings];
                          updatedSettings[index].tax_rate = parseFloat(e.target.value) || 0;
                          setPayrollSetting({ ...payrollSetting, tax_settings: updatedSettings });
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex justify-end items-center gap-4 fixed bottom-5 right-5 w-full">
        <Button
          className="px-5 dark:text-white"
          onClick={() => {
            submitShopPayrollSetting();
          }}
        >
          {loadingsubmitShopPayrollSetting ? <Loader className="animate-spin" /> : "Save"}
        </Button>
      </div>
    </div>
  );
};

export default PayrollSetting;
